import * as React from 'react'

import { Box, MediumIcon } from '@factorialco/deprecated-design-system'

import SelectorOption from './SelectorOption'

export interface Option {
  label: string
  value: string
  icon: MediumIcon
  disabled?: boolean
}

interface Props {
  value: string
  options: Option[]
  onChange: (value: string) => void
  readonly?: boolean
}

const ToggleSelector = ({ value, options, onChange, readonly = false }: Props) => {
  const disabled = readonly || options.length === 1

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="spaceBetween"
      border={{
        all: {
          width: 's2',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs100',
      }}
      background="grey000White"
      cursor={disabled ? 'default' : 'pointer'}
      padding="s4"
      gap="s4"
    >
      {options.map(({ value: groupValue, icon, label }) => (
        <SelectorOption
          key={groupValue}
          selectedValue={value}
          value={groupValue}
          icon={icon}
          label={label}
          onChange={onChange}
        />
      ))}
    </Box>
  )
}

export default ToggleSelector
